import { createCommand, type LexicalCommand } from "lexical";

export const OPEN_LINK_DIALOG_COMMAND: LexicalCommand<
  | {
      url: string;
      text: string;
      target: string | null;
      variant: "link" | "primary" | "secondary";
      size: "default" | "sm" | "lg";
      isFullWidth: boolean;
      nodeKey?: string;
    }
  | undefined
> = createCommand("OPEN_LINK_DIALOG_COMMAND");

export interface InsertImagePayload {
  altText: string;
  caption?: string;
  height?: number;
  maxWidth?: number;
  showCaption?: boolean;
  src: string;
  width?: number;
}

export const INSERT_IMAGE_COMMAND: LexicalCommand<InsertImagePayload> =
  createCommand("INSERT_IMAGE_COMMAND");
